//                                              [IMPORTS]
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useState } from "react";
//import "./Admin.css";
import "./Admin2.css";


//USERS IMPORTS
import NewUserForm from "./admin/user/NewUserForm";
import DeleteUser from "./admin/user/DeleteUser";
import UpdateUser from "./admin/user/UpdateUser";
import DeleteWebsite from "./admin/website/DeleteWebsite";
import UpdateWebsite from "./admin/website/UpdateWebsite";
import NewWebsiteForm from "./admin/website/NewWebsiteForm";
import AdminMesssages from "./admin/messages/AdminMessages";

export default function Admin() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  //active tabs
  const [activeTab, setActiveTab] = useState("users");
  const [data, setData] = useState([]);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  //                                                          SEARCH
  const [search, setSearch] = useState("");
  // filtriraj samo ako je activeTab === "users"
  const filteredUsers = activeTab.startsWith("users")
    ? data.filter(u =>
      (u.ime || "").toLowerCase().includes(search.toLowerCase()) ||
      String(u.klijentID).includes(search) ||
      (u.adresa || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.email || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.grad || "").toLowerCase().includes(search.toLowerCase())
    )
    : data;

  // filtriraj samo ako je activeTab === "websites"
  const filteredWebsites = activeTab.startsWith("websites")
    ? data.filter(w =>
      (w.naziv || "").toLowerCase().includes(search.toLowerCase()) ||
      String(w.sajtID).includes(search) ||
      String(w.ref_num).includes(search) ||
      (w.httpadresa || "").toLowerCase().includes(search.toLowerCase()) ||
      (w.ime || "").toLowerCase().includes(search.toLowerCase()) ||
      (w.email || "").toLowerCase().includes(search.toLowerCase())
    )
    : data;




  //                                                          MEHANIZAM ZA PROVERU TOKENA I ULOGE KORISNIKA




  useEffect(() => {
    const token = localStorage.getItem("token");

    // ako nema JWT → nema ulaza
    if (!token) {
      navigate("/login");
    }

    try {
      const decoded = jwtDecode(token);

      // Proveravamo ulogu iz tokena
      if (!decoded.role || decoded.role !== "administrator") {
        navigate("/roleredirect"); // ako nije admin → Error stranica
      }
    } catch (err) {
      // token ne može da se dekodira
      navigate("/error");
    }
  }, [navigate]);



  //                                                                  FETCH PODATAKA
  useEffect(() => {
    const fetchData = async () => {
      let endpoint = "";

      if (activeTab.startsWith("users")) endpoint = "clients";
      if (activeTab.startsWith("websites")) endpoint = "websites";
      if (activeTab === "messages") endpoint = "messages";
      if (!endpoint) return;

      const res = await axios.get(
        `/api/${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
      );

      setData(res.data);
    };

    fetchData();
  }, [activeTab]);

  return (




    <div className="min-vh-100 bg-dark text-white">
      <nav className="navbar navbar-dark bg-black px-4">
        <span className="navbar-brand fw-bold">
          <span className="text-primary">Alpha</span>PremiumSolutions Admin
        </span>
        <button className="hamburger d-lg-none" onClick={() => setSidebarOpen(true)}>☰</button>
        <button className="btn btn-outline-danger btn-sm"
          onClick={() => {
            localStorage.removeItem("token");
            navigate("/login");
          }}> Logout </button>
      </nav>

      {/* NAVBAR ZA STAVKE */}
      <div className="admin-layout">

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>

          <h5 className="sidebar-title">Dashboard</h5>

          {/* USERS */}
          <div className="sidebar-section">
            <p className="section-title">Users</p>
            <button onClick={() => setActiveTab("users")}>View</button>
            <button onClick={() => setActiveTab("users-new")}>New</button>
            <button onClick={() => setActiveTab("users-update")}>Update</button>
            <button onClick={() => setActiveTab("users-delete")}>Delete</button>
          </div>

          {/* WEBSITES */}
          <div className="sidebar-section">
            <p className="section-title">Websites</p>
            <button onClick={() => setActiveTab("websites")}>View</button>
            <button onClick={() => setActiveTab("websites-new")}>New</button>
            <button onClick={() => setActiveTab("websites-update")}>Update</button>
            <button onClick={() => setActiveTab("websites-delete")}>Delete</button>
          </div>

          {/* MESSAGES */}
          <div className="sidebar-section">
            <p className="section-title">Messages</p>
            <button onClick={() => setActiveTab("messages")}>View</button>
          </div>

          <hr />

          <button className="settings-btn" onClick={() => setActiveTab("settings")}>
            Settings
          </button>

        </aside>

        {sidebarOpen && (<div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />)}

        {/* CONTENT */}
        <main className="admin-content">
          {/* search */}
          {activeTab.endsWith("users") && (
            <input
              className="form-control mb-3 w-25"
              placeholder="Search by ID or name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          )}

          {activeTab.endsWith("websites") && (
            <input
              className="form-control mb-3 w-25"
              placeholder="Search by ID or name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          )}

          {activeTab === "users" && <TableRenderer data={filteredUsers} />}
          {activeTab === "users-new" && <NewUserForm />}
          {activeTab === "users-delete" && <DeleteUser />}
          {activeTab === "users-update" && <UpdateUser />}

          {activeTab === "websites" && <TableRenderer data={filteredWebsites} />}
          {activeTab === "websites-delete" && <DeleteWebsite />}
          {activeTab === "websites-update" && <UpdateWebsite />}
          {activeTab === "websites-new" && <NewWebsiteForm />}

          {activeTab === "messages" && <AdminMesssages />}

        </main>

      </div>
    </div>
  );

  function TableRenderer({ data }) {
    if (!data || data.length === 0) return <p>No data found.</p>;

    return (

      <div className="table-responsive position-relative">

        <table className="table table-dark-gray">
          <thead>
            <tr>
              {Object.keys(data[0]).map((key) => (
                <th key={key}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                {Object.values(row).map((value, i) => (
                  <td key={i}>{String(value)}</td>
                ))}

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
